document.addEventListener("DOMContentLoaded", function () {
    let acordeonAbierto = false;

    function abrirAcordeon() {
        const hash = window.location.hash;

        if (hash && !acordeonAbierto) {
            const accordionItem = Array.from(document.querySelectorAll('.sf__accordion-item')).find(item => {
                return item.innerText.includes("¿Cómo puedo hacer seguimiento a mi pedido?");
            });

            if (accordionItem) {
                if (!accordionItem.hasAttribute("id")) {
                    accordionItem.setAttribute("id", "seguimientoAcordeon");
                }

                const button = accordionItem.querySelector('.sf__accordion-button');

                if (button && !accordionItem.classList.contains('open')) {
                    button.click();
                }

                // Aseguramos que el desplazamiento se haga correctamente con una compensación adicional
                setTimeout(() => {
                    const yOffset = -80; // Ajuste para barras de navegación fijas
                    const y = accordionItem.getBoundingClientRect().top + window.pageYOffset + yOffset;

                    window.scrollTo({ top: y, behavior: 'smooth' });

                    acordeonAbierto = true;
                }, 500); // Aumentamos el tiempo de espera
            }
        }
    }

    abrirAcordeon();

    // Observador para cargar dinámicamente si el acordeón aún no está disponible
    const observer = new MutationObserver(() => {
        abrirAcordeon();
    });

    observer.observe(document.body, { childList: true, subtree: true });

    // Detenemos el observador después de 5 segundos para mejorar el rendimiento
    setTimeout(() => {
        observer.disconnect();
    }, 5000);
});





console.log("custom.js cargado correctamente");

console.log("Intentando abrir el acordeón con hash: " + hash);

